import { Chip } from "@mui/material";
import { alpha } from "@mui/material/styles";

/**
 * Status chip for the Generator Status Changes dashboard, built to the design
 * system chip spec (.cursor/rules/design-system.mdc): MUI semantic palette
 * colors in the light-filled variant (role `main` at 8% alpha + colored label),
 * never the solid dark-fill default and never the encamp* brand palette. The
 * neutral status renders as a plain outlined grey chip.
 *
 * `status` is the GeneratorStatusExceedanceStatus value (its runtime value is the
 * SCREAMING_SNAKE string, shared by both the Prisma- and GraphQL-generated
 * enums); unknown values fall back to neutral.
 */
const STATUS_ROLE: Record<string, "warning" | "info" | "success"> = {
  UNRESOLVED: "warning",
  PENDING: "info",
  RESOLVED: "success",
  // IGNORED (and anything unmapped) → neutral grey, handled below.
};

export function ExceedanceStatusChip({ status, label }: { status: string; label: string }) {
  const role = STATUS_ROLE[status];

  if (!role) {
    return <Chip size="small" variant="outlined" label={label} />;
  }

  return (
    <Chip
      size="small"
      label={label}
      sx={{
        color: `${role}.main`,
        bgcolor: (theme) => alpha(theme.palette[role].main, 0.08),
      }}
    />
  );
}
